import request from "../../../../../base/request";
import {findObject} from "../../../../editor/floatTool/securityCheck";

let suffixMap = {};

const initSuffixMap = (indexName, call) => {
    if (!(suffixMap[indexName])) {
        request({
            url: "/cm-sites-storage-management/resourceType/getAll",
            callBack: (data) => {
                let picture = findObject(data, "typeName", "图片");
                if (picture) {
                    suffixMap.picture = picture.suffixList;
                }
                let video = findObject(data, "typeName", "视频");
                if (video) {
                    suffixMap.video = video.suffixList;
                }
                let audio = findObject(data, "typeName", "音频");
                if (audio) {
                    suffixMap.audio = audio.suffixList;
                }
                call();
            }
        });
    } else {
        call();
    }
};

const loadList = ({indexName, start, size, search, other}) => {
    let params = {}
    let typeNameValue = ""
    if (indexName === "video") {
        typeNameValue = "视频"
    } else if (indexName === "picture") {
        typeNameValue = "图片"
    }
    // if (JSON.stringify(other) === "{}") {
    //     params = {pageNum: start, pageSize: size, keyword: search, ...other, typeName: typeNameValue}
    // }else{
        params = {pageNum: start, pageSize: size, keyword: search, ...other,typeName: typeNameValue}
    // }
    return new Promise((resolve, reject) => {
        initSuffixMap(indexName, () => {
            request({
                url: `/cm-sites-storage-management/zykCollection/collectionList`,
                contentType: "json",
                method: "post",
                body: params,
                callBack: (storageData) => {
                    storageData&& storageData.data && storageData.data.map(item => {
                        item.component = require(`../${indexName}/${indexName}`).default;
                    });
                    resolve(storageData);

                    // let md5Arr = [];
                    // data.data && data.data.map(item=>{
                    //     md5Arr.push(item.md5);
                    // });
                    // let md5s = md5Arr.join(",");
                    // if(md5s){
                    //     request({
                    //         url: "/storage/getStorageFileList",
                    //         body:{md5s,keyword:search,...other},
                    //         callBack:(storageData)=>{
                    //             storageData && storageData.map(item=>{
                    //                 item.component = require(`../${indexName}/${indexName}`).default;
                    //             });
                    //             resolve(storageData);
                    //         }
                    //     });
                    // }else{
                    //     resolve([]);
                    // }
                }
            })
        });
    })
};
export default loadList;